// Generate empty data for the last 12 weeks (all zeros by default)
const generateEmptyData = () => {
    const data = []
    const today = new Date()

    for (let i = 83; i >= 0; i--) {
        const date = new Date(today)
        date.setDate(date.getDate() - i)

        // Default to zero activity (no sample data)
        data.push({
            date: date.toISOString().split('T')[0],
            count: 0,
            level: 0,
        })
    }

    return data
}

const emptyData = generateEmptyData()

const levelColors = [
    'bg-white/5',      // 0 - no activity
    'bg-primary-900',  // 1 - low
    'bg-primary-700',  // 2 - medium-low
    'bg-primary-500',  // 3 - medium-high
    'bg-primary-400',  // 4 - high
]

export default function ActivityCalendar({ data }) {
    const activityData = data || emptyData

    // Group by week
    const weeks = []
    let currentWeek = []

    activityData.forEach((day, index) => {
        currentWeek.push(day)
        if (currentWeek.length === 7 || index === activityData.length - 1) {
            weeks.push([...currentWeek])
            currentWeek = []
        }
    })

    // Get month labels
    const getMonthLabels = () => {
        const labels = []
        let currentMonth = -1

        weeks.forEach((week, weekIndex) => {
            const date = new Date(week[0].date)
            const month = date.getMonth()

            if (month !== currentMonth) {
                labels.push({
                    month: date.toLocaleString('default', { month: 'short' }),
                    index: weekIndex,
                })
                currentMonth = month
            }
        })

        return labels
    }

    const monthLabels = getMonthLabels()
    const dayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

    return (
        <div className="glass-card p-6">
            <div className="mb-6">
                <h3 className="text-lg font-semibold text-white">Activity Calendar</h3>
                <p className="text-sm text-white/50">Your writing activity over the last 12 weeks</p>
            </div>

            <div className="overflow-x-auto">
                <div className="inline-block min-w-full">
                    {/* Month labels */}
                    <div className="flex mb-2 pl-10">
                        {monthLabels.map((label, index) => (
                            <div
                                key={index}
                                className="text-xs text-white/40"
                                style={{
                                    marginLeft: index === 0 ? 0 : `${(label.index - (monthLabels[index - 1]?.index || 0)) * 14 - 20}px`,
                                }}
                            >
                                {label.month}
                            </div>
                        ))}
                    </div>

                    <div className="flex gap-1">
                        {/* Day labels */}
                        <div className="flex flex-col gap-1 text-xs text-white/40 mr-2">
                            {dayLabels.map((day, index) => (
                                <div key={day} className="h-3 flex items-center">
                                    {index % 2 === 0 && day.slice(0, 1)}
                                </div>
                            ))}
                        </div>

                        {/* Calendar grid */}
                        <div className="flex gap-1">
                            {weeks.map((week, weekIndex) => (
                                <div key={weekIndex} className="flex flex-col gap-1">
                                    {week.map((day, dayIndex) => (
                                        <div
                                            key={day.date}
                                            className={`w-3 h-3 rounded-sm ${levelColors[day.level]} 
                                 hover:ring-1 hover:ring-white/30 transition-all cursor-pointer`}
                                            title={`${day.date}: ${day.count.toLocaleString()} words`}
                                        />
                                    ))}
                                    {/* Fill empty days at the end of the last week */}
                                    {weekIndex === weeks.length - 1 && week.length < 7 && (
                                        Array(7 - week.length).fill(null).map((_, i) => (
                                            <div key={`empty-${i}`} className="w-3 h-3" />
                                        ))
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Legend */}
                    <div className="flex items-center justify-end gap-2 mt-4 text-xs text-white/40">
                        <span>Less</span>
                        {levelColors.map((color, index) => (
                            <div key={index} className={`w-3 h-3 rounded-sm ${color}`} />
                        ))}
                        <span>More</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
